import script from "./castOrDirectorDetail.vue?vue&type=script&lang=ts&setup=true"
export * from "./castOrDirectorDetail.vue?vue&type=script&lang=ts&setup=true"

import "./castOrDirectorDetail.vue?vue&type=style&index=0&id=1c142ba2&lang=less&scoped=true"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c142ba2"]])

export default __exports__